import React, { Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Card from '../../Card/Card';
import StatisticsTabs from '../StatisticsTabs';
import StatisticsTable from '../StatisticsTable';
import StatisticsFilters from '../StatisticsFilters/StatisticsFilters';
import StatisticsSubSections from '../StatisticsSubSections';
import StatisticsCurrenciesControl from '../StatisticsCurrenciesControl';
import StatisticsConversionsTable from '../StatisticsConversionsTable/StatisticsConversionsTable';
import StatisticsGoalsTable from '../StatisticsGoalsTable';
import StatisticsTableChart from '../StatisticsTableChart';
import Pagination from '../../Pagination/Pagination';
import StatisticsControls from '../StatisticsControls';
import { isMaster } from '../statisticsHelpers';
import StatisticsShare from '../StatisticsShare';
import StatisticsCurrenciesTour from '../StatisticsCurrenciesTour';
import StatisticsPagerSettings from '../StatisticsPagerSettings';
import StatisticsExport from '../StatisticsExport/StatisticsExport';
import StatisticsRefreshButton from '../StatisticsRefreshButton';
import Skeleton from '@components/Skeleton/Skeleton';

const View = ({
  data: {
    tabs,
    config,
    currencies,
    hideFilters,
    isMembers,
    isMember,
    className,
    tab,
    loading,
    type,
    stats,
    total,
    page,
    limit,
    pageCount,
    isMounted,
    startCreateWebmasterPreset,
    startUpdateWebmasterPreset,
    startRemoveWebmasterPreset,
    showAlert,
    currency,
    isPagination,
    isChart,
    isSharing,
    requestParams,
    theme,
    shouldShowCurrenciesTour,
    filters: { template },
    hasTableEditingModalOpen,
    hasActionModalOpen,
    hasExportModalOpen,
    subIdModalOpen,
    isAggregated,
    slaves,
  },
  rowsCount,
  cardHeaderRef,
  handleTabChange,
  handleRefresh,
  handleSectionChange,
  changeCurrency,
  setPagesCount,
  handleDeleteSlave,
  handlePageChange,
  handleFilterUpdate,
  onSettingsUpdate,
  setSharingState,
  onCurrenciesTourFinishClick,
  onStatisticsViewTourFinishClick,
  handleHasEditingModalToggle,
  handleHasActionModalToggle,
  handleHasExportModalToggle,
  handleSubIdModalToggle,
}) => {
  return (
    <>
      <div className={`statistics ${className ? className : ''}`}>
        <div className="statistics-main-content">
        {/* Statistics Tabs */}
        <div className="statistics-nav-tabs" ref={cardHeaderRef}>
          {tabs.length > 0 && !hideFilters && (
            <StatisticsTabs tabs={tabs} type={type} onTabChange={handleTabChange} />
          )}
          <div className="statistics-refresh-mobile">
            <StatisticsRefreshButton onRefresh={handleRefresh} />
          </div>
          <button className="statistics-kebab-menu" onClick={handleHasActionModalToggle}></button>
        </div>

        {/* Master account filters */}
        {isMembers && (
          <div className="statistic-sub-section-container">
            <Row>
              <StatisticsFilters
                onCreatePreset={startCreateWebmasterPreset}
                onSavePreset={startUpdateWebmasterPreset}
                onRemovePreset={startRemoveWebmasterPreset}
                onFilterUpdate={handleFilterUpdate}
                onSettingsUpdate={onSettingsUpdate}
                onRefresh={handleRefresh}
                showAlert={showAlert}
                active={currency}
                currencies={currencies}
                onCurrencyChange={changeCurrency}
                tab={tab}
                handleSectionChange={handleSectionChange}
                stats={stats}
                total={total}
                type={type}
                currency={currency}
                isMember={isMember}
                isMembers={isMembers}
                isAggregated={isAggregated}
                slaves={slaves}
              />
            </Row>
            <div className="statistics-filters-controls">
              <div className="statistics-filters-addons">
                <button
                  className="statistics-subsection-controls-btn"
                  onClick={handleHasEditingModalToggle}
                ></button>
                {!isMember && (
                  <StatisticsShare
                    isLoading={isSharing}
                    setSharingState={setSharingState}
                    showAlert={showAlert}
                    requestParams={requestParams}
                    theme={theme}
                  />
                )}
                <StatisticsExport
                  hasExportModalOpen={hasExportModalOpen}
                  handleHasExportModalToggle={handleHasExportModalToggle}
                  stats={stats}
                  total={total}
                  type={type}
                  currency={currency}
                />
                <StatisticsRefreshButton onRefresh={handleRefresh} />
              </div>
            </div>
          </div>
        )}

        <div className="statistics-wrapper">
          {!hideFilters && !isMembers && (
            <Row>
              <Col>
                <StatisticsFilters
                  onCreatePreset={startCreateWebmasterPreset}
                  onSavePreset={startUpdateWebmasterPreset}
                  onRemovePreset={startRemoveWebmasterPreset}
                  onFilterUpdate={handleFilterUpdate}
                  onSettingsUpdate={onSettingsUpdate}
                  onRefresh={handleRefresh}
                  showAlert={showAlert}
                  active={currency}
                  currencies={currencies}
                  onCurrencyChange={changeCurrency}
                  tab={tab}
                  handleSectionChange={handleSectionChange}
                  stats={stats}
                  total={total}
                  type={type}
                  currency={currency}
                  isMember={isMember}
                  isMembers={isMembers}
                />
              </Col>
            </Row>
          )}

          {!isMembers && (
            <div className="statistic-sub-section-container">
              {!hideFilters && (
                <>
                  {tab.id && tab.tabs && (
                    <StatisticsSubSections type={type} onChange={handleSectionChange} {...tab} />
                  )}
                </>
              )}
              <div className="statistics-filters-controls">
                <div className="statistics-filters-addons">
                  <button
                    className="statistics-subsection-controls-btn"
                    onClick={handleHasEditingModalToggle}
                  ></button>
                  {!isMember && (
                    <StatisticsShare
                      isLoading={isSharing}
                      setSharingState={setSharingState}
                      showAlert={showAlert}
                      requestParams={requestParams}
                      theme={theme}
                    />
                  )}
                  <StatisticsExport
                    hasExportModalOpen={hasExportModalOpen}
                    handleHasExportModalToggle={handleHasExportModalToggle}
                    stats={stats}
                    total={total}
                    type={type}
                    currency={currency}
                  />
                  <StatisticsRefreshButton onRefresh={handleRefresh} />
                </div>
              </div>
            </div>
          )}

          {loading ? (
            <Skeleton className="statistics-skeleton" width="100%" height="535px" border="12px" />
          ) : (
            <>
              {/* Statistics Table */}
              {isChart && !isMaster && (type === 'times' || type === 'hourly') && (
                <StatisticsTableChart stats={stats} currency={currency} type={type} total={total} />
              )}
              {type === 'leads' && (
                <StatisticsConversionsTable
                  config={config}
                  currency={currency}
                  stats={stats}
                  page={page}
                  tab={type}
                  limit={limit}
                  setPagesCount={setPagesCount}
                  loading={loading}
                  isMounted={isMounted}
                  isMember={isMember}
                  isPagination={isPagination}
                  hasTableEditingModalOpen={hasTableEditingModalOpen}
                  handleHasEditingModalToggle={handleHasEditingModalToggle}
                  isSharing={isSharing}
                  setSharingState={setSharingState}
                  showAlert={showAlert}
                  requestParams={requestParams}
                  onRefresh={handleRefresh}
                  onSettingsUpdate={onSettingsUpdate}
                  hasActionModalOpen={hasActionModalOpen}
                  handleHasActionModalToggle={handleHasActionModalToggle}
                  hasExportModalOpen={hasExportModalOpen}
                  handleHasExportModalToggle={handleHasExportModalToggle}
                />
              )}
              {type === 'pixels' && (
                <StatisticsGoalsTable
                  config={config}
                  currency={currency}
                  stats={stats}
                  total={total}
                  limit={limit}
                  page={page}
                  setPagesCount={setPagesCount}
                  tab={type}
                  loading={loading}
                  isMounted={isMounted}
                  isMember={isMember}
                  template={template}
                  hasTableEditingModalOpen={hasTableEditingModalOpen}
                  handleHasEditingModalToggle={handleHasEditingModalToggle}
                  isSharing={isSharing}
                  setSharingState={setSharingState}
                  showAlert={showAlert}
                  requestParams={requestParams}
                  onRefresh={handleRefresh}
                  onSettingsUpdate={onSettingsUpdate}
                  hasActionModalOpen={hasActionModalOpen}
                  handleHasActionModalToggle={handleHasActionModalToggle}
                  hasExportModalOpen={hasExportModalOpen}
                  handleHasExportModalToggle={handleHasExportModalToggle}
                />
              )}

              {type !== 'leads' && type !== 'pixels' && (
                <StatisticsTable
                  config={config}
                  currency={currency}
                  stats={stats}
                  total={total}
                  page={page}
                  limit={limit}
                  setPagesCount={setPagesCount}
                  tab={type}
                  loading={loading}
                  isMembers={isMembers}
                  handleDeleteSlave={handleDeleteSlave}
                  isMounted={isMounted}
                  isMember={isMember}
                  isPagination={isPagination}
                  template={template}
                  hasTableEditingModalOpen={hasTableEditingModalOpen}
                  handleHasEditingModalToggle={handleHasEditingModalToggle}
                  isSharing={isSharing}
                  setSharingState={setSharingState}
                  showAlert={showAlert}
                  requestParams={requestParams}
                  onRefresh={handleRefresh}
                  onSettingsUpdate={onSettingsUpdate}
                  hasActionModalOpen={hasActionModalOpen}
                  handleHasActionModalToggle={handleHasActionModalToggle}
                  hasExportModalOpen={hasExportModalOpen}
                  handleHasExportModalToggle={handleHasExportModalToggle}
                />
              )}
            </>
          )}

        </div>
        </div>

          {isMembers && !loading && (
            <Card.Footer>
              {pageCount > 1 && (
                <Pagination
                  affectUrl
                  pageCount={pageCount}
                  onPageChange={handlePageChange}
                  activePage={page + 1}
                  scrollToAfterPageChanged={{ ref: cardHeaderRef.current }}
                />
              )}

              <StatisticsPagerSettings limit={limit} onSettingsUpdate={onSettingsUpdate} />
            </Card.Footer>
          )}

        {/* Statistics Pages */}
        {!isMembers && !loading && (
          <Card.Footer>
            {pageCount > 1 && (
              <Pagination
                affectUrl
                pageCount={pageCount}
                onPageChange={handlePageChange}
                activePage={page + 1}
                scrollToAfterPageChanged={{ ref: cardHeaderRef.current }}
              />
            )}

            <StatisticsPagerSettings limit={limit} onSettingsUpdate={onSettingsUpdate} />
          </Card.Footer>
        )}
      </div>
      {shouldShowCurrenciesTour ? (
        <StatisticsCurrenciesTour onFinishClick={onCurrenciesTourFinishClick} />
      ) : null}
    </>
  );
};

export default View;
